import React, { Component } from "react";
import {
  UVTransilluminator,
  Modal
} from "@learningblocks/storybook-components";

//import { toast } from 'react-toastify'
//import "react-toastify/dist/ReactToastify.css"
//import { css } from 'glamor'
//import Toast from '../../../../toast/Toast'

//import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss"
import "./TransilluminatorControls.scss";
import { DummyGelTable } from "./dummyData";


export class TransilluminatorControlsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scale: 1,
      pressed: false,
    };
  }

//   componentDidUpdate(){
//       this.setState({
//           temp: this.props.temp,
//           time: this.props.time
//       })
//   }


  closeModal = () => {
    this.props.showModal({ display: false });
  };



  submitGelExamined(){
    this.props.transilluminatorGelExmined({ id: 1, gelExamined: true})
    this.closeModal();
  }
  
  turnOnTransilluminator = () =>{
    const { open, containsGel } = this.props
    console.log('this.props of transi: ', this.props);
    if(open){
      //this.makeToast("", "Due to safety hazard, You can not turn on the transilluminator while its open, Close the lid first", "transilluminator lid is open")
      return
    }

    if(!open && !containsGel ){
      //this.makeToast("", "Place gel in transilluminator first befor turning on", "Place gel in transilluminator")
      return
    }

    this.props.turnOnTransilluminator({ id: 1, on: !this.props.on})
  }


  handleResize = () => {

    // let refSize = this.image.getBoundingClientRect();

    // let scale = Math.min(
    //   (refSize.width) / 162,
    //   (refSize.height) / 198
    // );

    // this.setState({
    //   scale: scale
    // })

  }
  // We need to attach a window event listener once the component is loaded in the DOM
  componentDidMount() {

    // Resize the scene and attach the resize method to the window resize event
    window.addEventListener("resize", this.handleResize)

  }
  componentWillUnmount(){

    window.removeEventListener("resize", this.handleResize)

  }
  componentDidUpdate(prevProps, prevState) {

    if(this.state.scale !== prevState.scale){
      this.handleResize()
    }
    if(this.props.display !== prevProps.display){
      this.handleResize()
    }
    if(this.props.notebookExpanded !== prevProps.notebookExpanded){
      this.handleResize()
    }

  }

  // makeToast = (type, msg, title) => {
  //   let color = ""
  //   if(type==="HINT"){
  //     color = colors.yellow1
  //   } else {
  //     color = colors.red1
  //   }

  //   toast(<Toast type={type} msg={msg} title={title} />,{
  //     className: css({
  //       border: "2px solid "+color,
  //       borderRadius: "6px",
  //       marginLeft: "-200px",
  //       minWidth: "400px"
  //     }),
  //     progressClassName: css({
  //       background: color
  //     }),
  //     position: "top-center",
  //     autoClose: 5000,
  //   });
  // }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        className="transilluminatorControlsModal"
        close={this.props.onClose}
        closeButton={true}
      > 
        <div onClick={(e)=>e.stopPropagation()}>
          <UVTransilluminator
            component={(
              <DummyGelTable
                gelExamined = {this.props.gelExamined}
                gelOrientation = {180}
                actualData = {this.props.actualData}
                level = {this.props.level}
                interactionProps = {this.props.interactionProps}
              />
            )}
            title="Transilluminator Controls"
            onToggleSwitch = {()=>{this.turnOnTransilluminator()}}
            switchedOn={this.props.on}
            onSubmit = {()=>{this.submitGelExamined()}}
            setNoteBookSection={this.props.setNoteBookSection}
            showModal={this.props.showModal}
            closeB
          />
        </div>
      </Modal>
    );
  }
}